import React from 'react';

const FullWidthIcon = props => (
  <svg viewBox="0 0 20 18" {...props}>
    <g stroke="none" strokeWidth="1" fillRule="evenodd">
      <rect opacity="0.6" x="3" y="16" width="14" height="2"/>
      <rect opacity="0.6" x="3" y="0" width="14" height="2"/>
      <rect x="0" y="4" width="20" height="10"/>
    </g>
  </svg>
);

export default FullWidthIcon;



// WEBPACK FOOTER //
// ./app/components/text-editor/icons/full-width-icon.js